<template>
  <el-dialog
    :visible.sync="open360DialogVisible"
    width="50%"
    center
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <iframe
      src="https://qa.openfreight.com.au/api/v3/public/migration-article"
      frameborder="0"
      class="w-100"
      style="height: 50vh;"
    />
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div class="dialog-footer__help">
        <span class="font-weight-bold">
          Need Help? Contact
          <el-link
            type="primary"
            href="tel:1300844373"
          >
            1300 844 373
          </el-link> or visit our
          <el-link
            type="primary"
            href="https://help.open360.com"
          >
            Help Hub
          </el-link>
        </span>
      </div>
      <div class="dialog-footer__actions">
        <el-button
          v-if="showContinueToOpenFreight"
          :type="openFreightButtonIsPrimary ? 'primary' : 'info'"
          @click="goToOpenFreight"
        >
          Continue to OpenFreight
        </el-button>
        <el-button
          :type="!openFreightButtonIsPrimary ? 'primary' : 'info'"
          @click="goToOpen360"
        >
          Go to Open360 <i class="fas fa-external-link-alt ml-1" />
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import Request, { POST } from '@/plugins/sdk/Request'

export default {
  props: {
    open360DialogVisible: {
      type: Boolean,
      required: true
    },
    showContinueToOpenFreight: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isRedirectingToOpen360: false
    }
  },
  computed: {
    openFreightButtonIsPrimary () {
      return this.showContinueToOpenFreight &&
        new Date() < new Date('2026-06-15T00:00:00Z')
    }
  },
  methods: {
    async canContinueToOpenFreight () {
      if (!await this.$session.active) {
        await this.$session.refresh()
      }
      console.log('Checking if user can continue to OpenFreight')
      let session = await this.$session.instance
      console.log(session.team.open360_only, session.profile.firebase_id)
      this.showContinueToOpenFreight = !session.team.open360_only && !session.profile.firebase_id
    },
    goToOpenFreight () {
      this.$emit('continue-to-openfreight')
    },
    async goToOpen360 () {
      await this.$session.instance
      this.isRedirectingToOpen360 = true

      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'open360/redirect'
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        const data = await response.json()
        if (data.data.redirect) {
          await this.$session.terminate()
          window.location.href = data.data.redirect
          return true
        }
      } else {
        await this.$session.terminate()
        this.$message.error('Failed to redirect to Open360.')
        return false
      }
      await this.$session.terminate()
      this.isRedirectingToOpen360 = false
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  align-items: center;
  width: 100%;
}

.dialog-footer__help {
  text-align: left;
  margin-right: 16px;
}

.dialog-footer__actions {
  margin-left: auto;
  display: flex;
  align-items: center;
}
</style>
